<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <Tabs v-model="tabType" type="card">
        <TabPane name="MP_PARENT_USER" label="家长端"></TabPane>
        <TabPane name="MP_TEACHER_USER" label="教师端"></TabPane>
        <TabPane name="MP_PLATFORM_USER" label="平台端"></TabPane>
      </Tabs>
      <Form
        ref="addInfoForm"
        :model="addInfo"
        label-position="right"
        :label-width="100"
        :rules="rule"
      >
        <FormItem label="协议类型：" prop="docType">
          <RadioGroup v-model="addInfo.docType">
            <Radio v-for="(item,index) in docTypeList" :key="index" :label="item.value">{{ item.name }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="协议内容：" prop="configVal">
          <div class="editor-item">
            <EditorV5 ref="editorV5"></EditorV5>
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="btn-block">
      <Button type="primary" @click="handleSave">保存</Button>
    </div>
    <SmsCodeModal
      ref="smsCodeModalRef"
      :check-type="checkType"
      @sendCode="handleSendCode"
    ></SmsCodeModal>
  </div>
</template>
<script>
import EditorV5 from '@c/Base/EditorV5';
import SmsCodeModal from './components/SmsCodeModal';
import commonApi from '@/request/common/index.js';
export default {
  components: {
    EditorV5,
    SmsCodeModal
  },
  data() {
    return {
      tabType: 'MP_PARENT_USER',
      addInfo: {
        docType: 'PROTOCOL',
        configVal: ''
      },

      rule: {
        configVal: [
          { required: true, message: '请输入协议内容', trigger: 'change' }
        ]
      },
      codeValue: '',
      msgCode: ''

    };
  },
  computed: {
    configType() {
      if (this.addInfo.docType.includes('KID_')) {
        return `MP_PARENT_KIDS_PRIVACY_POLICY`;
      } else {
        return `${this.tabType}_${this.addInfo.docType}`;
      }
    },
    checkType() {
      return this.tabType === 'MP_PLATFORM_USER' ? `MP_PARENT_USER_${this.addInfo.docType}:1` : `${this.configType}:0`;
    },
    docTypeList() {
      if (this.tabType === 'MP_PARENT_USER') {
        return [
          {
            value: 'PROTOCOL',
            name: '用户协议'
          },
          {
            value: 'PRIVACY',
            name: '隐私政策'
          },
          {
            value: 'KID_PRIVACY',
            name: '儿童隐私政策'
          }
        ];
      } else {
        return [{
          value: 'PROTOCOL',
          name: '用户协议'
        },
        {
          value: 'PRIVACY',
          name: '隐私政策'
        }];
      }
    }

  },
  watch: {
    tabType(newVal) {
      if (newVal !== 'MP_PARENT_USER' && this.configType === 'MP_PARENT_KIDS_PRIVACY_POLICY') {
        this.addInfo.docType = 'PROTOCOL';
      } else {
        this.getDocument();
      }
    },
    'addInfo.docType': {
      deep: true,
      handler() {
        this.getDocument();
      }
    }
  },
  created() {
    this.getDocument();
  },
  methods: {
    async getDocument() {
      const params = {
        configType: this.tabType === 'MP_PLATFORM_USER' ? `MP_PARENT_USER_${this.addInfo.docType}` : this.configType,
        orgId: this.tabType === 'MP_PLATFORM_USER' ? '1' : '0'
      };
      const res = await commonApi.getConfigDocumentApi(params);
      if (res.status === 200 && res.message) {
        const { codeValue, codeName } = res.message;
        this.codeValue = codeValue;
        codeName ? this.$refs.editorV5.setEditorContext(codeName) : this.$refs.editorV5.setEditorContext('');
      } else {
        this.$refs.editorV5.setEditorContext('');
      }
    },
    handleSave() {
      this.getContent();
      this.$nextTick(() => {
        this.$refs.addInfoForm.validate((valid) => {
          if (valid) {
            this.$refs.smsCodeModalRef.handleShow();
          }
        });
      });
    },
    async setDocument() {
      const params = {
        configType: this.tabType === 'MP_PLATFORM_USER' ? `MP_PARENT_USER_${this.addInfo.docType}` : this.configType, // 配置类型必传
        orgId: this.tabType === 'MP_PLATFORM_USER' ? '1' : '0', // 机构id必传，可传0
        configVal: this.addInfo.configVal, // 配置值必传
        smsCode: this.msgCode
      };
      console.log(this.addInfo.configVal, '拿到的数据---');
      const res = await commonApi.setConfigDocumentApi(params);
      if (res.status === 200) {
        this.$Message.success('保存成功');
        this.$refs.smsCodeModalRef.handleClose();
        this.getDocument();
      }
    },
    getContent() {
      console.log(this.$refs.editorV5.getEditorContext());
      this.addInfo.configVal = this.$refs.editorV5.getEditorContext();
    },
    handleSendCode(phoneCode) {
      this.msgCode = phoneCode;
      this.setDocument();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-block{
  padding-left: 100px;
}
.editor-item{
  width: 80%;
  height: calc(100vh - 320px);
  // /deep/.editor-box{
  //   width: 100%;
  //   height: 100%;
  // }
}
</style>
